import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';

interface FetcherParams {
  clientId: string;
  includeValue: boolean;
}

export interface ClientAssociatedProfileDTO {
  Name: string;
  Selected: boolean;
  Id: number;
  Value: number | null;
}

const fetchClientAssociatedProfiles = ({
  clientId,
  includeValue,
}: FetcherParams): Promise<ClientAssociatedProfileDTO[]> => {
  return authFetch(urlWithParams('/Consumer/ClientAssociatedProfiles', { clientId, includeValue }));
};

interface QueryParams {
  clientId: string;
  enabled?: boolean;
  includeValue?: boolean;
}

export const useClientAssociatedProfilesQuery = ({
  clientId,
  enabled = true,
  includeValue = false,
}: QueryParams) =>
  useQuery(
    queryKeys.clientAssociatedProfiles(clientId, includeValue),
    () => fetchClientAssociatedProfiles({ clientId, includeValue }),
    {
      enabled,
    },
  );
